import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "marketing-rep-dashboard" */ './MarketingRepDashboardCtnr'));
